namespace GeniuzPOS.AdvPromo {
    export interface VwAdvrRequest extends Serenity.ListRequest {
        PmGroupId?: string;
        PmId?: string;
        PluCode?: string;
        PromoCampaign?: string;
    }
}
